import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Phone } from "lucide-react";
import { toast } from "sonner";

export const PhoneCapture = () => {
  const { refresh } = useAuth();
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/me/phone", { phone });
      await refresh();
      toast.success("Mobile number saved");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not save number");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 mb-4" data-testid="phone-capture">
      <div className="font-bold text-slate-900 flex items-center gap-2"><Phone size={14} className="text-amber-600" /> Add your mobile number</div>
      <p className="text-xs text-slate-600 mt-1">Your rider will call this number if they can't find you.</p>
      <div className="mt-3 flex gap-2">
        <div className="flex items-center px-3 rounded-md border border-slate-200 bg-white text-sm text-slate-500">+91</div>
        <Input inputMode="numeric" maxLength={10} placeholder="98765 43210" value={phone}
          onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))} data-testid="phone-capture-input" />
        <Button className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={save} disabled={saving || phone.length !== 10} data-testid="phone-capture-save">
          {saving ? "Saving…" : "Save"}
        </Button>
      </div>
    </div>
  );
};
